import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Icons24 } from "../../Icons24Sprite/index.js";
import { IconWrapper } from "../../IconWrapper/index.js";
import { cn as clsx } from "../../../helpers/react.js";
import { useIndexTableDisabled } from "../IndexTableContext.js";
import '../../../assets/index19.css';const flightCell = "_flightCell_1v4w5_1";
const disabled = "_disabled_1v4w5_10";
const icon = "_icon_1v4w5_16";
const container = "_container_1v4w5_23";
const flightNumber = "_flightNumber_1v4w5_30";
const flag = "_flag_1v4w5_41";
const link = "_link_1v4w5_45";
const s = {
  flightCell,
  disabled,
  icon,
  container,
  flightNumber,
  flag,
  link
};
const IndexTableCellFlight = forwardRef(
  ({ className, showFlag, showLink, airlineIconSrc, children, flagIconName = "FlagTriangle", ...rest }, ref) => {
    const disabled2 = useIndexTableDisabled(rest);
    return /* @__PURE__ */ jsxs(
      "div",
      {
        ...rest,
        ref,
        className: clsx(
          s.flightCell,
          {
            [s.disabled]: disabled2
          },
          className
        ),
        children: [
          airlineIconSrc && /* @__PURE__ */ jsx(IconWrapper, { size: "md", children: /* @__PURE__ */ jsx(
            "img",
            {
              src: airlineIconSrc,
              className: clsx(s.icon, {
                [s.disabled]: disabled2
              })
            }
          ) }),
          /* @__PURE__ */ jsxs("div", { className: s.container, children: [
            /* @__PURE__ */ jsx("div", { className: s.flightNumber, children }),
            showFlag && /* @__PURE__ */ jsx(IconWrapper, { size: "sm", children: /* @__PURE__ */ jsx(Icons24, { name: flagIconName, className: s.flag }) }),
            showLink && /* @__PURE__ */ jsx(IconWrapper, { size: "sm", children: /* @__PURE__ */ jsx(Icons24, { name: "Link1", className: s.link }) })
          ] })
        ]
      }
    );
  }
);
export {
  IndexTableCellFlight
};
